import { Flex } from '@mantine/core';
import { memo, useCallback } from 'react';
import type { MonitorMetricCardType } from '../../types';
import {
	AcknowledgedIncidentsIcon,
	ErrorIcon,
	NormalIcon,
	OpenIncidentsIcon,
} from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MonitorMetrics {
	status_counts: {
		normal: number;
		error: number;
	};
	incident_counts: {
		active: number;
		acknowledged: number;
	};
}

export interface MetricsMonitorCardsProps {
	monitorMetrics: MonitorMetrics;
	onMetricCardClick?: (metricType: MonitorMetricCardType) => void;
}

export const MetricsMonitorCards = memo(
	({ monitorMetrics, onMetricCardClick }: MetricsMonitorCardsProps) => (
		<Flex
			py="lg"
			w="100%"
			justify="space-between"
			align="center"
			gap="md"
			direction={{ base: 'column', sm: 'row' }}
		>
			<MetricsOverviewCard
				title="Normal"
				value={monitorMetrics?.status_counts?.normal ?? 0}
				icon={NormalIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Normal'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Failed"
				value={monitorMetrics?.status_counts?.error ?? 0}
				icon={ErrorIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Error'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Open Incidents"
				value={monitorMetrics?.incident_counts?.active ?? 0}
				icon={OpenIncidentsIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Open Incidents'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Acknowledged Incidents"
				value={monitorMetrics?.incident_counts?.acknowledged ?? 0}
				icon={AcknowledgedIncidentsIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Acknowledged Incidents'),
					[onMetricCardClick]
				)}
			/>
		</Flex>
	)
);

MetricsMonitorCards.displayName = 'MetricsMonitorCards';
